/**
 * 颜色工具函数
 */

/**
 * 将十六进制颜色转换为 rgba 格式
 * @param {string} hex - 十六进制颜色值，如 '#EEEBFF' 或 '#fff'
 * @param {number} opacity - 透明度 0 ~ 1
 * @returns {string} rgba 颜色字符串
 */
export function getOpColor(hex, opacity = 1) {
  if (!hex || typeof hex !== 'string') return hex;
  let cleanHex = hex.trim().replace('#', '');
  if (cleanHex.length === 3) {
    cleanHex = cleanHex
      .split('')
      .map(char => char + char)
      .join('');
  }
  if (cleanHex.length === 6) {
    const r = parseInt(cleanHex.slice(0, 2), 16);
    const g = parseInt(cleanHex.slice(2, 4), 16);
    const b = parseInt(cleanHex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
  return hex;
}

export default {
  getOpColor
};
